/**
 *
 * FormInputWithDropdown
 *
 */

import React, { memo } from 'react';
import { Form, Input, Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage';

// import './style.scss';

// import styled from 'styled-components';

function FormInputWithDropdown(props) {
  const {
    label,
    inputFieldName,
    dropdownFieldName,
    dropdownOptions,
    dropDownValue,
    // dropDownFieldError,
    handleFieldBlur,
    handleFieldChange,
    dropDownPosition,
    placeholder,
    // inputFieldError,
    inputFieldValue,
    dropdownDefaultValue,
    enableDropDownSearch,
    dropDownSearch,
    dropdownPlaceholder,
    dropdownClassName,
    errors,
    touched,
    maxLength,
    inputType,
    handleOnInput,
    dropdownIcon,
    disabled = false,
    disableDropdown = false,
  } = props;

  let errorFieldName = '';

  if (errors[inputFieldName] && touched[inputFieldName])
    errorFieldName = inputFieldName;
  else if (errors[dropdownFieldName] && touched[dropdownFieldName])
    errorFieldName = dropdownFieldName;
  const options = {};
  if (maxLength) options.maxLength = maxLength;
  if (handleOnInput) options.onInput = handleOnInput;

  return (
    <div
      className={`form-input-wrapper ${errorFieldName ? 'error_border' : ''}`}
    >
      <Form.Field>
        <label>{label}</label>
        <Input
          className={`labeled-input-field-text ${
            dropdownOptions.length < 2
              ? 'single-dropdown-value'
              : 'multi-dropdown-value'
          }`}
          name={inputFieldName}
          type={inputType || 'text'}
          label={
            dropdownOptions.length < 2 ? (
              dropdownOptions[0].text
            ) : (
              <Dropdown
                placeholder={dropdownPlaceholder}
                defaultValue={dropdownDefaultValue}
                className={dropdownClassName}
                name={dropdownFieldName}
                options={dropdownOptions}
                value={dropDownValue}
                search={dropDownSearch}
                selection={enableDropDownSearch}
                // error={!!dropDownFieldError}
                onChange={handleFieldChange}
                onBlur={handleFieldBlur}
                icon={dropdownIcon}
                disabled={disabled || disableDropdown}
              />
            )
          }
          labelPosition={dropDownPosition}
          placeholder={placeholder}
          // error={!!inputFieldError}
          onBlur={handleFieldBlur}
          value={inputFieldValue}
          onChange={handleFieldChange}
          disabled={disabled}
          {...options}
        />
      </Form.Field>
      <ErrorMessage name={errorFieldName || inputFieldName} />
    </div>
  );
}

FormInputWithDropdown.propTypes = {
  label: PropTypes.any,
  inputFieldName: PropTypes.any,
  dropdownFieldName: PropTypes.any,
  dropdownOptions: PropTypes.any,
  dropDownValue: PropTypes.any,
  dropdownEvent: PropTypes.any,
  // dropDownFieldError: PropTypes.any,
  handleFieldBlur: PropTypes.any,
  handleFieldChange: PropTypes.any,
  dropDownPosition: PropTypes.any,
  placeholder: PropTypes.any,
  dropdownClassName: PropTypes.string,
  // inputFieldError: PropTypes.any,
  inputFieldValue: PropTypes.any,
  dropdownDefaultValue: PropTypes.any,
  enableDropDownSearch: PropTypes.bool,
  dropDownSearch: PropTypes.bool,
  dropdownPlaceholder: PropTypes.any,
  errors: PropTypes.object,
  touched: PropTypes.object,
  maxLength: PropTypes.any,
  inputType: PropTypes.string,
  handleOnInput: PropTypes.func,
  dropdownIcon: PropTypes.any,
  disabled: PropTypes.bool,
  disableDropdown: PropTypes.bool,
};

export default memo(FormInputWithDropdown);
